import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from './Modal';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

const FooterContainer = styled.footer`
  background: ${props => props.theme.background};
  border-top: 1px solid ${props => props.theme.border};
  padding: 1rem;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
  }
`;

const FooterText = styled.div`
  color: ${props => props.theme.textMuted};
  font-size: 0.875rem;
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 2rem;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const FooterLink = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.textMuted};
  font-size: 0.875rem;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #5865f2;
  }
`;

const PublicFooter = () => {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

  return (
    <FooterContainer>
      <FooterContent>
        <FooterText>
          © 2026 PlanMySemester. All rights reserved.
        </FooterText>
        <FooterLinks>
          <FooterLink as="a" href="https://buymeacoffee.com/tylerthedev" target="_blank" rel="noopener noreferrer">
            Donate
          </FooterLink>
          <FooterLink onClick={() => setIsPrivacyModalOpen(true)}>
            Privacy Policy
          </FooterLink>
          <FooterLink onClick={() => setIsTermsModalOpen(true)}>
            Terms of Service
          </FooterLink>
        </FooterLinks>
      </FooterContent>

      <Modal
        isOpen={isPrivacyModalOpen}
        onClose={() => setIsPrivacyModalOpen(false)}
        title="Privacy Policy"
      >
        <PrivacyPolicy />
      </Modal>

      <Modal
        isOpen={isTermsModalOpen}
        onClose={() => setIsTermsModalOpen(false)}
        title="Terms of Service"
      >
        <TermsOfService />
      </Modal>
    </FooterContainer>
  );
};

export default PublicFooter;
